import { useState, useRef, useCallback, useEffect } from 'react';

/**
 * Returns true if the page hasn't been clicked in the last N milliseconds
 *
 * @param delay
 */
export const usePageNotClicked = ({ delay }: { delay: number }): boolean => {
  const [pageNotClicked, setPageNotClicked] = useState<boolean>(true);
  const lastClickTime = useRef<Date | null>();

  const handleClick = useCallback(() => {
    const clickTime = new Date();
    setPageNotClicked(false);

    lastClickTime.current = clickTime;

    setTimeout(() => {
      if (clickTime === lastClickTime.current) {
        setPageNotClicked(true);
      }
    }, delay);
  }, [delay, lastClickTime]);

  useEffect(() => {
    window.addEventListener('mousedown', handleClick);

    return () => {
      window.removeEventListener('mousedown', handleClick);
    };
  });

  return pageNotClicked;
};
